<div class="container-fluid">
	<div class="row my-3 align-items-center">
		<div class="col-10 col-sm">
			<h2>{{response_info.response.id == 0 ? 'Crear' : 'Editar'}} respuestas para {{response_info.form.title}}</h2>
		</div>
	</div>
	<app-loading [is_loading]="is_loading"></app-loading>
	<div class="row">
		<div class="col-6" *ngIf="response_info.form.is_response_title_required">
			<h3 class="fw-bold">Nombre de {{response_info.form.title}}</h3>
			<input *ngIf="response_info.form.is_response_title_required == 1" type="text" class="form-control" [(ngModel)]="response_info.response.title" placeholder="Titulo de la respuesta">
		</div>
		<div class="col-6">
			<ng-container *ngIf="change_user_enabled">
				<h3 class="fw-bold">Cliente</h3>
				<app-search-users (user_selected)="changeResponseUser($event)" [reset_on_search]="false" [type]="'CLIENT'" ></app-search-users>
			</ng-container>
			<ng-container *ngIf="!change_user_enabled">
				<h3 class="fw-bold">Cliente</h3>
				<div>{{response_info.user.name}}</div>
			</ng-container>
		</div>
		<!--div class="col-12 col-sm-3" *ngIf="response_info.response.id != 0 && response_info.user">
			<div class="text-center">
				<h3 class="fw-bold">Cliente</h3>
				<p>{{response_info.user.name}}</p>
			</div>
		</div-->

	</div>
	<form class="mt-2" (submit)="save($event)" ngNativeValidate>
		<ng-container *ngFor="let ai of response_info.answers;let i = index">
			<label class="fw-bold my-1" >{{ai.question.question}}</label>
			<label *ngIf="isLabel(ai.question) && ai.question.help" class="d-block text-muted fst-italic mb-2">{{ai.question.help}}</label>
			<div class="card p-3 my-1" *ngIf="!isLabel(ai.question)">
				<div class="row">
					<div class="col-12">
						<label *ngIf="ai.question.help" >{{ai.question.help + ':'}}</label>
						<ng-container *ngIf="!isOptionType(ai.question)">
							<textarea *ngIf="ai.question.type == 'textarea'" [name]="'answer'+i" class="form-control" rows="3" [(ngModel)]="ai.answer.answer_text" [required]="ai.question.required == 1"></textarea>
							<input *ngIf="ai.question.type != 'textarea'" [type]="getInputType(ai.question.type)" [name]="'answer'+i" class="form-control" [(ngModel)]="ai.answer.answer_text" [required]="ai.question.required == 1">
						</ng-container>
						<select *ngIf="ai.question.type == 'select'" [name]="'answer'+i" class="form-control" [(ngModel)]="ai.answer.answer_text" [required]="ai.question.required == 1">
							<option value="">Seleccionar...</option>
							<option *ngFor="let opt of getOptions(ai.question)" [value]="opt">{{opt}}</option>
						</select>
						<ng-container *ngIf="ai.question.type == 'checkbox'">
							<div *ngFor="let opt of getOptions(ai.question); let oi = index" class="form-check">
								<input class="form-check-input" type="checkbox" [id]="'answer'+i+'_'+oi" [checked]="isChecked(i, opt)" (change)="toggleCheckbox(i, opt, $event)">
								<label class="form-check-label" [for]="'answer'+i+'_'+oi">{{opt}}</label>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</ng-container>
		<button type="submit" class="btn btn-primary float-end my-3">Guardar</button>
	</form>
</div>
